import * as yup from 'yup';
import { checkCNPJ } from './companyRegister';
export const initialValues = {
	name: '',
	email: '',
	phone: '',
	subject: '',
	message: '',
	company: '',
	cnpj: '',
};

const schema = yup.object().shape({
	name: yup.string().required('Nome é obrigatório!'),
	email: yup.string().email('Email deve ter um formato válido!').required('Email é obrigatório!'),
	phone: yup
		.string()
		.notRequired()
		.matches(/([0-9]{4,5}-[0-9]{4})/, { message: 'Telefone inválido!', excludeEmptyString: true }),
	subject: yup.string().required('Assunto é obrigatório!'),
	message: yup.string().required('Mensagem é obrigatório!'),
	company: yup.string().when('subject', {
		is: val => val == 'Suporte para EMPRESAS',
		then: schema => schema.required('Mensagem é obrigatória')
	}),
	cnpj: yup.string().when('subject', {
		is: val => val == 'Suporte para EMPRESAS',
		then: schema => schema
			.matches(/^[0-9A-Za-z]{14}$/, { message: 'CNPJ inválido!', excludeEmptyString: true })
			.required('CNPJ é obrigatório!')
			.test('cnpj', 'CNPJ inválido!', checkCNPJ),
	}),
});

export default schema;
